import {
  GetSegmentContactsRequestPayload,
  GetSegmentContactsResponse,
  GetSegmentsResponse,
  ISegment,
  ISegmentForm,
  SegmentFilters,
  UpdateSegmentForm,
} from 'types/segments/segments.types';

export const GET_SEGMENTS_REQUEST = 'GET_SEGMENTS_REQUEST';
export const GET_SEGMENTS_SUCCESS = 'GET_SEGMENTS_SUCCESS';
export const GET_SEGMENTS_FAILURE = 'GET_SEGMENTS_FAILURE';

export const GET_SEGMENT_REQUEST = 'GET_SEGMENT_REQUEST';
export const GET_SEGMENT_SUCCESS = 'GET_SEGMENT_SUCCESS';
export const GET_SEGMENT_FAILURE = 'GET_SEGMENT_FAILURE';

export const CREATE_SEGMENT_REQUEST = 'CREATE_SEGMENT_REQUEST';
export const CREATE_SEGMENT_SUCCESS = 'CREATE_SEGMENT_SUCCESS';
export const CREATE_SEGMENT_FAILURE = 'CREATE_SEGMENT_FAILURE';

export const UPDATE_SEGMENT_REQUEST = 'UPDATE_SEGMENT_REQUEST';
export const UPDATE_SEGMENT_SUCCESS = 'UPDATE_SEGMENT_SUCCESS';
export const UPDATE_SEGMENT_FAILURE = 'UPDATE_SEGMENT_FAILURE';

export const DELETE_SEGMENT_REQUEST = 'DELETE_SEGMENT_REQUEST';
export const DELETE_SEGMENT_SUCCESS = 'DELETE_SEGMENT_SUCCESS';
export const DELETE_SEGMENT_FAILURE = 'DELETE_SEGMENT_FAILURE';

export const CLEAR_SEGMENT_STATE = 'CLEAR_SEGMENT_STATE';

export const UPLOAD_SEGMENT_CONTACTS_REQUEST =
  'UPLOAD_SEGMENT_CONTACTS_REQUEST';
export const UPLOAD_SEGMENT_CONTACTS_SUCCESS =
  'UPLOAD_SEGMENT_CONTACTS_SUCCESS';
export const UPLOAD_SEGMENT_CONTACTS_FAILURE =
  'UPLOAD_SEGMENT_CONTACTS_FAILURE';

export const GET_SEGMENT_CONTACTS_REQUEST = 'GET_SEGMENT_CONTACTS_REQUEST';
export const GET_SEGMENT_CONTACTS_SUCCESS = 'GET_SEGMENT_CONTACTS_SUCCESS';
export const GET_SEGMENT_CONTACTS_FAILURE = 'GET_SEGMENT_CONTACTS_FAILURE';

export const EXPORT_SEGMENT_CONTACTS_REQUEST =
  'EXPORT_SEGMENT_CONTACTS_REQUEST';
export const EXPORT_SEGMENT_CONTACTS_SUCCESS =
  'EXPORT_SEGMENT_CONTACTS_SUCCESS';
export const EXPORT_SEGMENT_CONTACTS_FAILURE =
  'EXPORT_SEGMENT_CONTACTS_FAILURE';
export const CLEAR_EXPORT_SEGMENT_CONTACTS_SUCCESS =
  'CLEAR_EXPORT_SEGMENT_CONTACTS_SUCCESS';

export const REMOVE_CONTACT_FROM_SEGMENT_REQUEST =
  'REMOVE_CONTACT_FROM_SEGMENT_REQUEST';
export const REMOVE_CONTACT_FROM_SEGMENT_SUCCESS =
  'REMOVE_CONTACT_FROM_SEGMENT_SUCCESS';
export const REMOVE_CONTACT_FROM_SEGMENT_FAILURE =
  'REMOVE_CONTACT_FROM_SEGMENT_FAILURE';
export const CLEAR_REMOVE_CONTACT_FROM_SEGMENT_SUCCESS =
  'CLEAR_REMOVE_CONTACT_FROM_SEGMENT_SUCCESS';

export const ADD_CONTACTS_TO_SEGMENT_REQUEST =
  'ADD_CONTACTS_TO_SEGMENT_REQUEST';
export const ADD_CONTACTS_TO_SEGMENT_SUCCESS =
  'ADD_CONTACTS_TO_SEGMENT_SUCCESS';
export const ADD_CONTACTS_TO_SEGMENT_FAILURE =
  'ADD_CONTACTS_TO_SEGMENT_FAILURE';
export const CLEAR_ADD_CONTACTS_TO_SEGMENT_SUCCESS =
  'CLEAR_ADD_CONTACTS_TO_SEGMENT_SUCCESS';

export interface GetSegmentsRequestAction {
  type: typeof GET_SEGMENTS_REQUEST;
  payload: SegmentFilters;
  [key: string]: any;
}

export interface GetSegmentsSuccessAction {
  type: typeof GET_SEGMENTS_SUCCESS;
  payload: GetSegmentsResponse;
  [key: string]: any;
}

export interface GetSegmentsFailureAction {
  type: typeof GET_SEGMENTS_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface GetSegmentRequestAction {
  type: typeof GET_SEGMENT_REQUEST;
  payload: string;
  [key: string]: any;
}

export interface GetSegmentSuccessAction {
  type: typeof GET_SEGMENT_SUCCESS;
  payload: ISegment;
  [key: string]: any;
}

export interface GetSegmentFailureAction {
  type: typeof GET_SEGMENT_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface CreateSegmentRequestAction {
  type: typeof CREATE_SEGMENT_REQUEST;
  payload: ISegmentForm;
  [key: string]: any;
}

export interface CreateSegmentSuccessAction {
  type: typeof CREATE_SEGMENT_SUCCESS;
  payload: ISegment;
  [key: string]: any;
}

export interface CreateSegmentFailureAction {
  type: typeof CREATE_SEGMENT_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface UpdateSegmentRequestAction {
  type: typeof UPDATE_SEGMENT_REQUEST;
  payload: UpdateSegmentForm;
  [key: string]: any;
}

export interface UpdateSegmentSuccessAction {
  type: typeof UPDATE_SEGMENT_SUCCESS;
  payload: ISegment;
  [key: string]: any;
}

export interface UpdateSegmentFailureAction {
  type: typeof UPDATE_SEGMENT_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface DeleteSegmentRequestAction {
  type: typeof DELETE_SEGMENT_REQUEST;
  payload: string;
  [key: string]: any;
}

export interface DeleteSegmentSuccessAction {
  type: typeof DELETE_SEGMENT_SUCCESS;
  payload: string;
  [key: string]: any;
}

export interface DeleteSegmentFailureAction {
  type: typeof DELETE_SEGMENT_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface ClearSegmentStateAction {
  type: typeof CLEAR_SEGMENT_STATE;
  [key: string]: any;
}

export interface UploadSegmentContactsRequestPayload {
  id: string;
  contacts: any[];
  lookupBy: string;
}

export interface UploadSegmentContactsRequestAction {
  type: typeof UPLOAD_SEGMENT_CONTACTS_REQUEST;
  payload: {
    id: string;
    contacts: any[];
    lookupBy: string;
  };
  [key: string]: any;
}

export interface UploadSegmentContactsSuccessAction {
  type: typeof UPLOAD_SEGMENT_CONTACTS_SUCCESS;
}

export interface UploadSegmentContactsFailureAction {
  type: typeof UPLOAD_SEGMENT_CONTACTS_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface GetSegmentContactsRequestAction {
  type: typeof GET_SEGMENT_CONTACTS_REQUEST;
  payload: GetSegmentContactsRequestPayload;
  [key: string]: any;
}

export interface GetSegmentContactsSuccessAction {
  type: typeof GET_SEGMENT_CONTACTS_SUCCESS;
  payload: GetSegmentContactsResponse;
  [key: string]: any;
}

export interface GetSegmentContactsFailureAction {
  type: typeof GET_SEGMENT_CONTACTS_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface ExportSegmentContactsRequestAction {
  type: typeof EXPORT_SEGMENT_CONTACTS_REQUEST;
  payload: string;
  [key: string]: any;
}

export interface ExportSegmentContactsSuccessAction {
  type: typeof EXPORT_SEGMENT_CONTACTS_SUCCESS;
  payload: Blob;
  [key: string]: any;
}

export interface ExportSegmentContactsFailureAction {
  type: typeof EXPORT_SEGMENT_CONTACTS_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface ClearExportSegmentContactsSuccessAction {
  type: typeof CLEAR_EXPORT_SEGMENT_CONTACTS_SUCCESS;
  [key: string]: any;
}

export interface RemoveContactFromSegmentRequestPayload {
  segmentId: string;
  contactId: string;
}

export interface RemoveContactFromSegmentRequestAction {
  type: typeof REMOVE_CONTACT_FROM_SEGMENT_REQUEST;
  payload: RemoveContactFromSegmentRequestPayload;
  [key: string]: any;
}

export interface RemoveContactFromSegmentSuccessAction {
  type: typeof REMOVE_CONTACT_FROM_SEGMENT_SUCCESS;
  payload: string; // contactId
  [key: string]: any;
}

export interface RemoveContactFromSegmentFailureAction {
  type: typeof REMOVE_CONTACT_FROM_SEGMENT_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface ClearRemoveContactFromSegmentSuccessAction {
  type: typeof CLEAR_REMOVE_CONTACT_FROM_SEGMENT_SUCCESS;
  [key: string]: any;
}

export interface AddContactsToSegmentRequestPayload {
  segmentId: string;
  contactIds: string[];
}

export interface AddContactsToSegmentRequestAction {
  type: typeof ADD_CONTACTS_TO_SEGMENT_REQUEST;
  payload: AddContactsToSegmentRequestPayload;
  [key: string]: any;
}

export interface AddContactsToSegmentSuccessAction {
  type: typeof ADD_CONTACTS_TO_SEGMENT_SUCCESS;
  [key: string]: any;
}

export interface AddContactsToSegmentFailureAction {
  type: typeof ADD_CONTACTS_TO_SEGMENT_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface ClearAddContactsToSegmentSuccessAction {
  type: typeof CLEAR_ADD_CONTACTS_TO_SEGMENT_SUCCESS;
  [key: string]: any;
}

export type SegmentsActionTypes =
  | GetSegmentsRequestAction
  | GetSegmentsSuccessAction
  | GetSegmentsFailureAction
  | GetSegmentRequestAction
  | GetSegmentSuccessAction
  | GetSegmentFailureAction
  | CreateSegmentRequestAction
  | CreateSegmentSuccessAction
  | CreateSegmentFailureAction
  | UpdateSegmentRequestAction
  | UpdateSegmentSuccessAction
  | UpdateSegmentFailureAction
  | DeleteSegmentRequestAction
  | DeleteSegmentSuccessAction
  | DeleteSegmentFailureAction
  | ClearSegmentStateAction
  | UploadSegmentContactsRequestAction
  | UploadSegmentContactsSuccessAction
  | UploadSegmentContactsFailureAction
  | GetSegmentContactsRequestAction
  | GetSegmentContactsSuccessAction
  | GetSegmentContactsFailureAction
  | ExportSegmentContactsRequestAction
  | ExportSegmentContactsSuccessAction
  | ExportSegmentContactsFailureAction
  | ClearExportSegmentContactsSuccessAction
  | RemoveContactFromSegmentRequestAction
  | RemoveContactFromSegmentSuccessAction
  | RemoveContactFromSegmentFailureAction
  | ClearRemoveContactFromSegmentSuccessAction
  | AddContactsToSegmentRequestAction
  | AddContactsToSegmentSuccessAction
  | AddContactsToSegmentFailureAction
  | ClearAddContactsToSegmentSuccessAction;
